import { MatrixQuestInterface } from "@swivl-mono/types";
import * as React from "react";
import { FaPlus } from "react-icons/fa";

import { QuestsModel, WorkflowsJourney } from "../../../../Models/Quests/Quests.Model";
import MatrixQuestMenu from "../MatrixTable/Components/MatrixQuestMenu";
import "./DefaultUnhandledDropdown.scss";

interface Props {
  matrix: MatrixQuestInterface;
  questsModel: any;
  workflows: WorkflowsJourney[];
  setDefaultUnhandled: any;
  enabled: boolean;
}
interface State {
  showMenu: boolean;
}
export default class DefaultUnhandledDropdown extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = { showMenu: false };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.setQuest = this.setQuest.bind(this);
  }

  toggleMenu() {
    if (!this.props.enabled) {
      return;
    }
    this.setState({ showMenu: !this.state.showMenu });
  }
  setQuest(questSlug) {
    if (!this.props.enabled) {
      return;
    }

    this.setState({ showMenu: false });
    this.props.setDefaultUnhandled(questSlug);
  }

  render() {
    let title: any = this.props.matrix ? QuestsModel.nameForQuest(this.props.matrix.data.defaultUnhandled) : null;

    if (!title) {
      title = (
        <span>
          <FaPlus /> Set Default Unhandled
        </span>
      );
    }
    let className = title && title.length > 0 ? "DefaultUnhandledDropdown" : "DefaultUnhandledDropdown noQuest";
    if (!this.props.enabled) {
      className += " disabled";
    }
    const menu = this.state.showMenu ? (
      <MatrixQuestMenu workflows={this.props.workflows} setQuest={this.setQuest} setShowMenu={this.toggleMenu} />
    ) : null;
    return (
      <div className={className}>
        <div className="quest font-poppins font-semibold" onClick={this.toggleMenu}>
          {title}
        </div>
        {menu}
      </div>
    );
  }
}
